/**
 * Every piece of UI that requires javascript should have its own
 * javascript file. Use this file as a template for structuring
 * all JS source files.
 *
 * {Document Title}
 * {Description}
 */

(function (window, $) {
  'use strict';
  var document = window.document;

  $(document).ready(function () {
    $('.table-flexible').each(function (i, obj) {
      const $header = $(this).find($('.card-header'));
      const $body = $(this).find($('.card-body'));
      $body.on('scroll', function () {
        $header.scrollLeft($(this).scrollLeft());
      });
    });
  });
})(window, jQuery);
